export default {
    namespaced: true,

    state:{
        windowWidth: window.innerWidth,
    },
    getters:{
        pcVersion:(s)=>{
            return s.windowWidth > 770;
        }
    },
    mutations:{
        changeWindowWidth:(s, width)=>{
            s.windowWidth = width;
        }
    },
}